import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";

export default function Sidebar() {
  const location = useLocation();

  const menu = [
    { name: "Dashboard", path: "/", icon: "D" },
    { name: "Plans", path: "/plans", icon: "P" },
    { name: "Add Plan", path: "/plans/add", icon: "+" },
    { name: "Schools", path: "/schools", icon: "S" },
    { name: "Add School", path: "/schools/add", icon: "+" },
    { name: "Payments", path: "/payments", icon: "B" },

  ];

  return (
    <aside className="sidebar-container">
      <div className="sidebar-brand">
        <span className="sidebar-logo">SA</span>
        <div>
          <h2 className="sidebar-title">School ERP</h2>
          <p>Super Admin</p>
        </div>
      </div>

      <ul className="sidebar-menu">
        {menu.map((item) => (
          <li key={item.path}>
            <Link
              className={`sidebar-link ${
                location.pathname === item.path ? "active" : ""
              }`}
              to={item.path}
              aria-current={location.pathname === item.path ? "page" : undefined}
            >
              <span className="sidebar-link-icon">{item.icon}</span>
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
}
